import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function profiles() {
    return {
        index,
        getProfileDetail
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`profile/search${params}`);
    }

    function getProfileDetail(id) {
        return axiosInstance.get(`profile/get?id=${id}`);
    }
}
